import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sessionId })
      .then((res) => navigate("/admin", { state: { user: res.data }, replace: true }))
      .catch((err) =>
        navigate("/login", {
          state: { error: formatApiError(err.response?.data?.detail) },
          replace: true,
        })
      );
  }, [location, navigate]);

  return (
    <div className="min-h-screen workspace-light bg-[#EDF4FB] flex items-center justify-center" data-testid="auth-callback">
      <Loader2 size={28} className="animate-spin text-sky-600" />
    </div>
  );
}
